/** Elements that must not toggle bulk selection when clicked (visit text / controls). */
export const VISIT_CARD_NO_BULK_SELECT_SELECTOR = "[data-visit-card-no-bulk-select]";

const INTERACTIVE_SELECTOR =
  "button, a, input, textarea, select, label, [role='button'], [role='checkbox']";

export function shouldVisitCardClickToggleBulkSelect(
  target: EventTarget | null,
  options: { editMode: boolean; isEditingHeader: boolean }
): boolean {
  if (!options.editMode || options.isEditingHeader) return false;
  if (!(target instanceof HTMLElement)) return false;
  if (target.closest(VISIT_CARD_NO_BULK_SELECT_SELECTOR)) return false;
  if (target.closest(INTERACTIVE_SELECTOR)) return false;
  return true;
}
